(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.hs-dtc-option').forEach(function (group) {
      group.querySelectorAll('.hs-dtc-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.hs-dtc-pill').forEach(function (p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
          // Visual selection only. Wiring this to the hidden variant input
          // requires mapping option-value combinations to variant IDs for
          // the chosen product — flagged as a follow-up.
        });
      });
    });

    document.querySelectorAll('.hs-dtc-bundle input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var group = radio.closest('.hs-dtc-bundles');
        if (group) {
          group.querySelectorAll('.hs-dtc-bundle').forEach(function (card) {
            card.classList.remove('is-selected');
          });
        }
        radio.closest('.hs-dtc-bundle').classList.add('is-selected');

        var input = radio.closest('.hs-dtc-hero__info').querySelector('[data-hs-variant-input]');
        if (input && radio.value) {
          input.value = radio.value;
          // Fire real change/input events so subscription apps (Seal, etc.)
          // that listen for the product form's variant field actually
          // notice the switch and re-render their own pricing widget.
          // Without this, our hidden input updates silently and Seal's
          // widget keeps showing the old variant's price.
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    // Apply the initial selected state on load (the first bundle radio is
    // checked by default in the markup, but that needs a matching class
    // for the visible highlight, not just the underlying input state).
    var initialChecked = document.querySelector('.hs-dtc-bundle input[type="radio"]:checked');
    if (initialChecked) initialChecked.closest('.hs-dtc-bundle').classList.add('is-selected');
  });
})();
